import { useController } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { getContactName } from 'helpers/_helpers';
import ContactCreator from '../ContactCreator/ContactCreator';
import { useMemo, useState } from 'react';
import { SearchSelect } from 'lib';

export const AlternateContacts = ({
  sheetDetailsClasses,
  control,
  currContractorContacts,
  CloseIcon,
  getValues,
  setCurrContractorContacts,
  setValue,
}) => {
  const {
    field: { onChange, value: contractorContactsIds },
  } = useController({
    name: 'alternateContacts',
    control,
    defaultValue: [''],
  });
  const [ContactCreatorForm, setContactCreatorForm] = useState(false);

  const contactOptions = useMemo(() => (
    currContractorContacts.filter((contact) => (
      !contractorContactsIds.find((cont) => contact._id === cont)
    )).sort((a, b) => a.name.localeCompare(b.name))
  ), [currContractorContacts, contractorContactsIds])


  const handleSelectContact = (i) => (contactId) => {
    const id = contactId ?? '';

    const nextValue = contractorContactsIds.map((t, index) => (index === i ? id : t));
    onChange(nextValue);
  };

  const handleContactCreateForm = (value) => {
    if (value === false) {
      setContactCreatorForm(value);
      return;
    }
    setContactCreatorForm(value.toString());
  };

  const handleEmailRemoving = (i) => () => {
    const nextValue = contractorContactsIds.filter((_, index) => index !== i);
    if (!nextValue.length) {
      nextValue.push('');
    }
    onChange(nextValue);
  };

  return (
    <>
      {!!contractorContactsIds?.length &&
        contractorContactsIds.map((contactId, index) => (
          <Grid item xs={12} className={sheetDetailsClasses.zeroPaddingTop} key={contactId + '_' + index}>
            <label htmlFor="alternateContacts">
              <Typography variant="body1" color="textSecondary">
                {index === 0 ? 'Primary Contact' : `Alternate Contact ${index}`}:
              </Typography>
              <div className={sheetDetailsClasses.flexBox}>
                <div className={sheetDetailsClasses.flexGrow}>
                  <SearchSelect
                    value={contactId}
                    onChange={handleSelectContact(index)}
                    options={[
                      currContractorContacts.find((c) => c._id === contactId),
                      ...contactOptions,
                    ].filter(Boolean)}
                    getOptionLabel={(option) => getContactName(option)}
                    inputProps={{ id: `alternateContacts[${index}]`, 'aria-label': 'Contact' }}
                    footer={
                      <Button
                        variant="text"
                        className={sheetDetailsClasses.primaryTextButton}
                        onClick={() => handleContactCreateForm(index)}
                        disableRipple
                      >
                        + Create New Contact
                      </Button>
                    }
                  />
                </div>
                <IconButton
                  className={sheetDetailsClasses.deleteLocationButton}
                  onClick={handleEmailRemoving(index)}
                  aria-label="Delete"
                  disableTouchRipple
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </label>
          </Grid>
        ))}
      <Grid item xs={12} className={sheetDetailsClasses.zeroPadding}>
        {ContactCreatorForm ? (
          <ContactCreator
            values={getValues()}
            setCurrContractorContacts={setCurrContractorContacts}
            setValue={setValue}
            setContactCreatorForm={setContactCreatorForm}
            contactIndex={ContactCreatorForm}//index of contact id slector's arr or false
          />
        ) : null}
      </Grid>
    </>
  );
};
